<template>
  <custom-dialog
    class="send-email-dialog"
    width="450px"
    :title="model.title"
    :visible="visible"
    v-on="$listeners"
  >
    <div class="dialog-body">
      <el-form
        :model="form"
        :rules="rules"
        size="small"
        ref="form"
        label-position="top"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('fms_send_email_dialog.fa_piao_bian_hao')">
              <el-input
                v-model="form.invoiceNum"
                :disabled="true"
                style="100%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              :label="$t('fms_send_email_dialog.you_xiang')"
              prop="buyerEmail"
            >
              <el-input
                v-model="form.buyerEmail"
                style="100%"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        size="small"
        @click="closeDialog"
      >{{ $t('Common.com_cancel') }}</el-button>
      <el-button
        size="small"
        type="primary"
        @click="confirm"
      >{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],

  data() {
    return {
      form: {
        invoiceNum: '',
        buyerEmail: '',
      },
    };
  },
  mounted() {
    this.init();
  },

  computed: {
    rules() {
      return {
        buyerEmail: {
          required: true,
          type: 'email',
          message: this.$t('fms_send_email_dialog.yjgsbzq'),
        }
      };
    },
  },
  methods: {
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },
    onProductSnChange(item) {
      this.form.productCode = item ? item.productCode : '';
      this.form.websiteCode = item ? item.websiteCode : '';
      this.form.websiteName = item ? item.websiteName : '';
    },
    onWebsiteChange(item) {
      this.form.websiteCode = item ? item.websiteCode : '';
    },
    // 确认保存
    confirm: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.saveUpdate();
      });
    },

    // 保存编辑
    saveUpdate: function () {
      this.$postJSON(apis.invoiceSendEmail, this.form).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.closeDialog();
        this.$emit('success', this.form);
      });
    },
    init() {
      if (this.model.data) {
        const data = this.model.data;
        this.form.invoiceNum = data.invoiceNum;
        this.form.buyerEmail = data.buyerEmail;
      }
    }
  },
};
</script>

<style lang="scss">
.entire-item-dialog {
  .title {
    color: rgba(0, 0, 0, 0.85);
    font-weight: bold;
    line-height: 24px;
    font-size: 16px;
    margin-bottom: 24px;
  }
  .left {
    border-right: 1px solid #eef2f8;
    padding-right: 24px;
  }
  .right {
    padding-left: 24px;
  }
  .el-form-item--small.el-form-item {
    margin-bottom: 14px;
  }
}
</style>
